import styles from './WorkTypes.less';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RefineRadio from '../RefineRadio/RefineRadio';
import { ScreenReaderOnly } from 'seek-style-guide/react';
import { optimisticUpdateWorkTypeClicked } from 'src/store/search/optimistic/refinement';

export default class WorkTypes extends Component {
  static propTypes = {
    handleSelection: PropTypes.func.isRequired,
    workTypes: PropTypes.array.isRequired,
    active: PropTypes.bool.isRequired
  };

  shouldComponentUpdate({ active }) {
    return active;
  }

  render() {
    const { handleSelection, workTypes } = this.props;

    return (
      <nav
        role="navigation"
        aria-labelledby="RefineWorkType"
        className={styles.root}
      >
        <ScreenReaderOnly>
          <h1 id="RefineWorkType">Refine by Work Type</h1>
        </ScreenReaderOnly>
        <RefineRadio
          multiSelect={true}
          handleSelection={handleSelection}
          preNavigationAction={optimisticUpdateWorkTypeClicked}
          labelledBy="RefineWorkType"
          options={workTypes}
          path="/jobs"
          data-automation="refineWorkType"
        />
      </nav>
    );
  }
}
